export default __webpack_public_path__ + "static/media/Bicho Canasto.f71bd870.jpg";